// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-module--header--5Mia0","header__site-title":"Header-module--header__site-title--3KKSB"};